/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import userApi from '../../../services/userApi';

export const useGetUserAttributes = (userId, enabled) =>
  useQuery({
    queryKey: ['userAttributes', userId],
    queryFn: () => userApi.getUserAttributes(userId),
    enabled,
    select: response => response?.data.at(0)?.user_attributes
  });

export const useGetUserByReferenceID = (referenceId, enabled) =>
  useQuery({
    queryKey: ['userByReferenceID', referenceId],
    queryFn: () => userApi.getUserByReferenceID(referenceId),
    enabled,
    select: response => response?.data
  });
